import { signInWithEmailAndPassword, signInWithEmailLink, signInWithPopup } from "firebase/auth";
import { auth } from "./firebase";
import { issueMsg } from "../common/issueMsg";

const loginFirebase = async (type,loginProvider, password = null) => {
  if (type === 'email' ){
    try {
      await signInWithEmailAndPassword(
        auth,
        loginProvider,
        password
      );
      return true;
    } catch (error) {
      if (error.code === 'auth/invalid-email') {
        issueMsg('"Please enter a correct email address');
      } else if (error.code === 'auth/user-not-found') {
        issueMsg('The provided email address has not been registered as a user');
      } else if (error.code === 'auth/wrong-password') {
        issueMsg('The password is incorrect');
      } else if (error.code === 'auth/too-many-requests') {
        issueMsg('The number of incorrect password attempts has exceeded the specified limit');
      } else if (error.code === 'auth/user-disabled') {
        issueMsg('The user is disabled');
      } else {
        issueMsg('An error occurred during login',error.code);
      }
      console.error(error);
      return false;
    }
  } else if(type === 'mailLink') {
    try {
      await signInWithEmailLink(auth, loginProvider, window.location.href);
    } catch(error) {
      issueMsg('Failed to log in with email authentication',error.code)
    }
  } else if(type === 'google') {
    try{
      await signInWithPopup(auth, loginProvider);
    } catch(error) {
      if (error.code === 'auth/popup-closed-by-user') {
        issueMsg('Login with Google ID has been canceled');
      } else {
        console.log(error.code);
        alert(error.message);
      }
    }
  }
}

export default loginFirebase;
